import { gql } from '@apollo/client';

export const CORE_SAVED_SEARCH_FIELDS = gql`
    fragment CoreSavedSearchFields on SavedSearch {
        id
        title
        default
        primaryInterest
        businessLocations
        tenants {
            purpose
            density
            size
            typeOfCenter
            typeOfFacility
        }
        space {
            purpose
            density
            size
            typeOfCenter
            typeOfFacility
        }
        connections {
            connectionType
        }
        products {
            areYou
            productTypes
        }
        isComplete
        createdAt
    }
`;
